import type {
  EditorElement,
  EditorPluginOptions,
  EditorPluginPropertyOptions,
  Fragment,
} from '../../types';
import type { ComponentType } from 'react';

export const MACRO_PLACEHOLDER_PLUGIN_ID = 'macroPlaceholder' as const;
export type MacroPlaceholderPluginID = typeof MACRO_PLACEHOLDER_PLUGIN_ID;

// A macro is technically just a fragment containing Nodes
export type Macro = Fragment;
export type MacroPlaceholderType = 'plainText' | 'macroText' | 'macroInline' | 'macroBlock';

export type MacroPlaceholderPluginElement = Readonly<
  EditorElement & {
    type: MacroPlaceholderPluginID;
    referenceID: string;
    name?: string;
  }
>;

// A macro placeholder may be rendered as a MacroChip (if REPORTER_MACRO_PLACEHOLDER_CHIP is on) or as a legacy <template element (if REPORTER_MACRO_PLACEHOLDER_CHIP is off)
export enum MacroPlaceholderRenderMode {
  TemplateElement = 'templateElement',
  ChipElement = 'chipElement',
}

export type MacroPlaceholderPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
    renderMode?: MacroPlaceholderRenderMode;
  }
>;

export type MacroPlaceholderPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    MacroPlaceholderPluginOptions & {
      pluginID: MacroPlaceholderPluginID;
      component: ComponentType<any>;
      pluginName: string;
    }
>;
